export const locale = {
  title: 'About Messaging for Family Members',
  content:
    'Selecting a family member’s name will display their messages. \n\n' +
    'You can view and send messages for dependents up to age 13. You will not be able to view or send messages for a spouse or any dependents over age 13.',
  close: 'Close',
};
